import { useContext, useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import { AppContext } from 'contexts/AppContext';

export default function IntercomWidget() {
  const { userData, brandData } = useContext(AppContext);

  useEffect(() => {
    if (!brandData?.features?.enableIntercom) return;
    if (!userData?.UserID) return;
    
    Intercom({
      app_id: 'niknqoui',
      user_id: String(userData.UserID),
      name: userData.userName,
      email: userData.userEmail,
    });
  }, [userData]);

  return <></>;
}